export default "* Ask & Liv-bankoplade blank\n* Ask & Liv-brikker til følelsesbanko\n* Evt. laminering af bankoplader";